import { supabase } from '@/lib/supabase';

type CreateProjectProps = {
  name?: string;
  category?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  status?: string;
  kpis: CreateProjectKpiProps[];
  member_invites: CreateProjectMemberInvite[];
  org_id: number;
};

type CreateProjectKpiProps = {
  name: string;
  description?: string;
  max_value?: number;
  type: string;
  unit: string;
};

type CreateProjectMemberInvite = {
  org_member_id: string;
  deeplink_prefix: string;
};

export const createProject = async (input: CreateProjectProps) => {
  const { error, data } = await supabase.rpc('create_project', {
    body: input,
  });

  if (error) {
    throw error;
  }

  return data;
};
